<div class="dashboard-container">
  <afoone-dashboard-card
    *ngFor="let item of dashboardApps"
    [title]="item.name"
    [description]="item.tooltip"
    [imgSrc]="item.img"
    [link]="item.route"
  ></afoone-dashboard-card>
</div>
